<template>
  <div class="addInformTheForwarding">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">{{ Form.documentname || '' }}</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">公文转发审批流程</div>
        <blank height="7"> </blank>
        <a-button
          class="detial-top-btn"
          type="primary"
          icon="printer"
          v-if="Form.state == 2"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane
          key="2"
          tab="表单流程"
          v-if="Form.state > 0 && version == ''"
        />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">公文登记录入</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照表单要求添加信息，并提交进入审批流程
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">公文信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions bordered>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace"
              >标题<span class="required">*</span>
            </span>
            <a-input
              class="w800"
              placeholder="请添加标题"
              v-model="Form.documentname"
              :disabled="disabled"
              @change="eightyfive('documentname', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">公文来源 </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.sourcedocuments"
              :disabled="disabled"
              @change="eightyfive('sourcedocuments', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">发文字号 </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.postShopName"
              :disabled="disabled"
              @change="eightyfive('postShopName', 85)"
            />
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"
              >签收部门<span class="required">*</span>
            </span>
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"
              >登记签收人<span class="required">*</span>
            </span>
            <a-input
              disabled
              class="w200"
              placeholder="请添加"
              v-model="Form.signPeople"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"
              >登记签收日期<span class="required">*</span>
            </span>
            <a-date-picker
              class="w200"
              v-model="Form.signTime"
              :valueFormat="dateFormat"
              :disabled="disabled"
            />
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered>
          <a-descriptions-item :span="3">
            <span slot="label">主送<span class="required">*</span> </span>
            <a-select
              mode="multiple"
              placeholder="请添加"
              class="w800"
              :filter-option="filterOption"
              v-model="Form.groupIds"
              :disabled="disabled"
            >
              <a-select-option
                v-for="i in GroupList"
                :value="i.id"
                :key="i.id"
                >{{ i.groupName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="3" v-if="Form.state == 2">
            <span slot="label" class="whiteSpace">浏览数据 </span>
            <div v-show="Form.state == 2">
              <a-row type="flex">
                <a-col :span="8"
                  >通知人数：<span
                    class="personNumber"
                    @click="lookPersonNumber(1)"
                    >{{ personalCounts.noticeCount }}</span
                  >人
                </a-col>
                <a-col :span="8"
                  >已传阅人数：<span
                    class="personNumber"
                    @click="lookPersonNumber(2)"
                    >{{ personalCounts.circulate }}</span
                  >人
                </a-col>
                <a-col :span="8"
                  >未传阅人数：<span
                    class="personNumber"
                    @click="lookPersonNumber(3)"
                  >
                    {{ personalCounts.notCirculate }}</span
                  >人
                </a-col>
              </a-row>
            </div>
          </a-descriptions-item>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace"> 来文内容解读 </span>
            <a-input
              class="w800"
              v-model="Form.content"
              placeholder="请添加内容"
              type="textarea"
              :rows="8"
              :disabled="disabled"
              @change="eightyfive('content', 200)"
            />
          </a-descriptions-item>

          <a-descriptions-item :span="3">
            <span slot="label">附 件<span class="required">*</span> </span>
            <div class="fileDiv">
              <div class="fileDiv-left">
                <div v-for="(record, index) in upfileList" :key="index">
                  <a-button type="link">
                    {{ record.filename + '.' + record.fileformat }}
                  </a-button>
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="goDetial(record)"
                  >
                    查看
                  </a-button>
                  <a-divider type="vertical" />
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="
                      download(
                        record.mongoFileId,
                        record.filename,
                        record.fileformat
                      )
                    "
                  >
                    下载
                  </a-button>
                  <a-divider type="vertical" v-if="!disabled" />
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="removeFiles(index)"
                    v-if="!disabled"
                  >
                    删除
                  </a-button>
                </div>
              </div>
              <div v-if="!disabled">
                <a-upload
                  name="file"
                  :multiple="false"
                  action="#"
                  @change="uploadFiles"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                >
                  <a-button icon="plus"> 添加附件 </a-button>
                </a-upload>
                支持扩展名：.rar .zip .doc .docx .pdf .jpg...
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
        </div>
        <!-- <a-button
          v-if="Form.state === 3 ? true : false"
          type="primary"
          @click="cancelPro('1')"
          :style="{ marginRight: '20px' }"
        >
          提交
        </a-button>
        <div v-if="Form.state === 3 ? false : true">
          <a-button
            v-if="proQueryParams.showApproveBtn === '1' ? true : false"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button>
        </div> -->
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/noticeForward/details?id="
      skipPageReqFlag="/InformTheForwardingDetial"
    >
      <div class="Oprintd-title">北京民政工业总公司公文转发审批表单</div>
      <div class="Oprintd-cont offDetial">
        <div class="Oprintd-item">
          <div class="Oprintd-td">
            <a-descriptions bordered size="small">
              <a-descriptions-item label="标题" :span="3">
                {{ Form.documentname }}
              </a-descriptions-item>
              <a-descriptions-item label="公文来源" :span="1.5">
                {{ Form.sourcedocuments }}
              </a-descriptions-item>
              <a-descriptions-item label="发文字号" :span="1.5">
                {{ Form.postShopName }}
              </a-descriptions-item>
              <a-descriptions-item label="签收部门" :span="3">
                {{ Form.organizationName }}
              </a-descriptions-item>
              <a-descriptions-item :span="1.5">
                <span slot="label" class="whiteSpace">登记签收人 </span>
                {{ Form.signPeople }}
              </a-descriptions-item>
              <a-descriptions-item :span="1.5">
                <span slot="label" class="whiteSpace">登记签收日期 </span>
                {{ Form.signTime }}
              </a-descriptions-item>
              <a-descriptions-item label="主送" :span="3">
                <span v-for="(i, index0) in Form.groupIds" :key="index0">
                  <span v-for="v in GroupList" :key="v.id">
                    <span v-if="i == v.id" class="Oprintd-item-span">{{
                      v.groupName
                    }}</span>
                  </span>
                </span>
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <div class="Oprintd-item-gw">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns2"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
    <!-- 浏览数据 -->
    <a-modal v-model="visible" title="浏览数据" :footer="null" :width="800">
      <a-table
        :pagination="false"
        :columns="LookColumns"
        :data-source="LookList"
        :row-key="(record) => record.id"
        :loading="lookloadIng"
      >
        <span slot="index" slot-scope="text, record, index">{{
          index + 1 + (page - 1) * 10
        }}</span>
        <span slot="documentConsultStatus" slot-scope="text">{{
          text == 1 ? '已传阅' : '未传阅'
        }}</span>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  updateOfficialForwarding,
  OfficialForwardingDetial,
  addOfficialForwarding,
  getPersonalCounts,
  getHistoryVersion
} from './api/api'
import { saveFile, getFile } from '@/http/url'
import { getSuffix, formatDate, formatDateNoDetails } from '@/assets/js/auth'
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
export default {
  data() {
    return {
      confirmLoading: false,
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      id: '',
      dateFormat: 'YYYY-MM-DD',

      version: '',
      upfileList: [], //公文附件列表
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分
      formDTOList: [],
      isPrint: false, // 打印弹窗
      columns2: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'center'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center'
        }
      ],
      workbench: '',
      personalCounts: {}, //浏览数据
      visible: false,
      LookColumns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '状态',
          dataIndex: 'documentConsultStatus',
          key: 'documentConsultStatus',
          scopedSlots: { customRender: 'documentConsultStatus' },
          align: 'center'
        },
        {
          title: '部门',
          dataIndex: 'organizationName',
          key: 'organizationName',
          align: 'cneter'
        },
        {
          title: '姓名',
          dataIndex: 'userName',
          key: 'userName',
          align: 'left'
        }
      ],
      LookList: [],
      total: 0,
      page: 1,
      size: 10,
      circulateType: 1,
      lookloadIng: false,
      pIsedit: ''
    }
  },
  components: {
    approvalSubmission,
    approvalChart
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      GroupList: (state) => state.app.GroupList, // 分组列表
      queryUserList: (state) => state.app.queryUserList // 用户列表
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.getByType()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.workbench = this.$route.query.workbench
      ? this.$route.query.workbench
      : ''
    if (this.id) {
      if (this.version) {
        this.getHistoryVersionFn()
      } else {
        this.load()
      }
    } else {
      // 新建
      this.Form.signPeople = this.$store.state.app.userInfo.fullName
      let date = new Date()
      this.$set(this.Form, 'signTime', formatDateNoDetails(date))
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    //浏览记录弹出
    lookPersonNumber(type) {
      this.circulateType = type
      this.page = 1
      this.getLookList()
      this.visible = true
    },
    // 浏览记录分页
    pageChange(pageber) {
      this.page = pageber
      this.getLookList()
    },
    //获取浏览人数列表
    getLookList() {
      let Pform = {
        circulateType: this.circulateType,
        id: this.id,
        page: this.page,
        size: this.size
      }
      this.lookloadIng = true
      getPersonalCounts(Pform).then((res) => {
        this.lookloadIng = false
        if (res.data.code == 0) {
          this.LookList = res.data.data
          this.total = res.data.count
        }
      })
    },
    ...mapActions([
      'getorganizationUserList',
      'getGroupList',
      'getqueryUserList'
    ]),
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '公文转发-' + this.Form.documentname + this.$printFormatDate(new Date())
    },
    load() {
      let obj = {
        id: this.id
      }
      if (this.workbench) {
        obj.workbench = this.workbench
      }
      OfficialForwardingDetial(obj).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.upfileList = this.Form.file
          if (this.Form.personalCounts) {
            //浏览数据存在
            this.personalCounts = this.Form.personalCounts
          }
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    },
    getHistoryVersionFn() {
      getHistoryVersion({ id: this.id, version: this.version }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.upfileList = this.Form.file
          if (this.Form.personalCounts) {
            //浏览数据存在
            this.personalCounts = this.Form.personalCounts
          }
        }
      })
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.load()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    // 多选搜索按名字搜
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    // 获取当前页面所需字典表
    getByType() {
      //
      this.getorganizationUserList()
      // 分组
      this.getGroupList()
      // 用户列表
      this.getqueryUserList()
    },
    goback() {
      if (this.workbench) {
        this.$router.push('/')
      } else {
        this.$router.push('/InformTheForwarding')
      }
    },
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        this.saveFileFn(file.file)
      }
    },
    beforeUpload() {
      return false
    },
    saveFileFn(file) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]

          fileData.createTime = this.formatDateIt(new Date())
          this.upfileList.push(fileData)
        }
      })
    },
    // 移除
    removeFiles(index) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.upfileList.splice(index, 1)
          this.$message.success('删除成功')
        }
      })
    },
    goDetial(item) {
      // 查看
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        // window.open(item.kkFileUrl + encodeURIComponent(item.fileUrl))
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    download(mongoFileId, filename, fileformat) {
      // 下载附件
      getFile(mongoFileId).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.documentname) {
        this.$message.error('请输入标题')
        return false
      }
      if (!this.Form.signTime) {
        this.$message.error('请选择登记签收日期')
        return false
      }
      if (!this.Form.groupIds || this.Form.groupIds.length == 0) {
        this.$message.error('请选择主送')
        return false
      }
      if (!this.upfileList || this.upfileList.length == 0) {
        this.$message.error('请添加附件')
        return false
      }
      this.confirmLoading = true
      this.saveFormFn('保存')
    },

    submitFn() {
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.documentname) {
        this.$message.error('请输入标题')
        return false
      }
      if (!this.Form.signTime) {
        this.$message.error('请选择登记签收日期')
        return false
      }
      if (!this.Form.groupIds || this.Form.groupIds.length == 0) {
        this.$message.error('请选择主送')
        return false
      }
      if (!this.upfileList || this.upfileList.length == 0) {
        this.$message.error('请添加附件')
        return false
      }
      if (this.Form.state > 0) {
        this.Form.draft = 2
        this.saveFormFn('添加')
      } else {
        this.$confirm({
          title: '确定提交吗?',
          okType: 'danger',
          onOk: () => {
            this.Form.draft = 2
            this.saveFormFn('提交')
          }
        })
      }
    },
    saveFormFn(type) {
      this.Form.file = this.upfileList
      // this.Form.appId = this.$route.meta.appId
      this.Form.appId = this.$APPID.GWZAPPID
      this.Form.skipPageReqFlag = '/InformTheForwardingDetial'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        updateOfficialForwarding(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.load()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.Form.organizationName = organizationName
        addOfficialForwarding(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.load()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addInformTheForwarding {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .personNumber {
        color: rgba(0, 0, 0, 0.85);
        font-size: 19px;
        cursor: pointer;
      }
    }
  }
  .fileDiv {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
}
.whiteSpace {
  white-space: nowrap;
}
</style>
<style lang="scss">
.addInformTheForwarding {
  .detial-cont {
    .detial-cont-view {
      .ant-descriptions-bordered .ant-descriptions-view {
        border: none;
      }
      .ant-descriptions-view {
        border-radius: 0;
      }
      .ant-descriptions-item-label {
        background: #fff;
      }
      .ant-descriptions-bordered .ant-descriptions-view {
        border-top: rgba(255, 87, 51, 1) solid 1px;
        border-left: rgba(255, 87, 51, 1) solid 1px;
      }
      .ant-descriptions-row {
        border-bottom: rgba(255, 87, 51, 1) solid 1px;
      }
      .ant-descriptions-bordered .ant-descriptions-item-label,
      .ant-descriptions-bordered .ant-descriptions-item-content {
        border-right: rgba(255, 87, 51, 1) solid 1px;
        //   text-align: right;
      }
    }
  }
}
// 打印内容不能嵌套写样式

.Oprintd-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: rgba(255, 87, 51, 1);
}
.Oprintd-cont-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border: 1px solid #cecece;
  padding: 0 23px;
}
.Oprintd-item-span {
  margin-right: 10px;
}
.Oprintd-td {
  .ant-descriptions-view {
    border-radius: 0;
  }
  .ant-descriptions-item-label {
    background: #fff;
  }
  .ant-descriptions-bordered .ant-descriptions-view {
    border-top: rgba(255, 87, 51, 1) solid 1px;
    border-left: rgba(255, 87, 51, 1) solid 1px;
    color: rgba(255, 87, 51, 1);
  }
  .ant-descriptions-row {
    border-bottom: rgba(255, 87, 51, 1) solid 1px !important;
    color: rgba(255, 87, 51, 1);
  }
  .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-descriptions-bordered .ant-descriptions-item-content {
    border-right: rgba(255, 87, 51, 1) solid 1px;
    color: rgba(255, 87, 51, 1);
    overflow: hidden;
  }
}
.Oprintd-item-gw {
  margin-top: 20px;
  .ant-table-bordered .ant-table-thead > tr > th,
  .ant-table-bordered .ant-table-tbody > tr > td {
    // border: 1px solid rgba(255, 87, 51, 1);
    color: rgba(255, 87, 51, 1);
  }
}
</style>
<!-- 此处和公文发文一致 -->
<style scoped src="@/views/OfficialDocument/css/offcialPrintMoadl.css"></style>


// WEBPACK FOOTER //
// src/views/InformTheForwarding/detial.vue